import { Link } from 'react-router-dom';
import { cn } from 'utils/cn';

export const Button = ({ text, light, className, to, children }) => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <Link to={to}>
      <button
        onClick={scrollToTop}
        className={cn(
          'bg-primary hover:bg-primary-hover text-white font-medium rounded-md px-6 py-3 transition-all duration-200 shadow-sm hover:shadow',
          light &&
            'bg-white text-primary border-2 border-primary hover:bg-primary hover:text-white',
          className
        )}>
        {children || text?.toUpperCase()}
      </button>
    </Link>
  );
};
